import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { PayrollCadence } from "@/actions/ssr/settings/getPayrollCadenceSSR";

const payrollCadenceSlice = createSlice({
  name: "payrollCadence",
  initialState: null as PayrollCadence | null,
  reducers: {
    setPayrollCadence(_state, action: PayloadAction<PayrollCadence | null>) {
      return action.payload;
    },
  },
});

export const { setPayrollCadence } = payrollCadenceSlice.actions;
export default payrollCadenceSlice.reducer;
